export default __webpack_public_path__ + "static/media/breakfast_6.41187711.jpg";